import { api } from '../client';
import type { User, Role } from '../../types/user';

export const usersApi = {
  list: () =>
    api.get<{ success: boolean; users: User[] }>('/api/users'),

  create: (data: { username: string; password: string; email?: string; role: string }) =>
    api.post<{ success: boolean; user: User }>('/api/users', data),

  update: (userId: string, data: Partial<{ username: string; email: string; role: string }>) =>
    api.put<{ success: boolean }>(`/api/users/${userId}`, data),

  delete: (userId: string) =>
    api.delete<{ success: boolean }>(`/api/users/${userId}`),

  toggleActive: (userId: string) =>
    api.put<{ success: boolean }>(`/api/users/${userId}/toggle`),

  resetPassword: (userId: string, password: string) =>
    api.put<{ success: boolean }>(`/api/users/${userId}/password`, { password }),
};

export const rolesApi = {
  list: () =>
    api.get<{ success: boolean; roles: Role[]; permissionKeys: Array<{ key: string; label: string }> }>('/api/roles'),

  updatePermissions: (roleName: string, permissions: string[]) =>
    api.put<{ success: boolean }>(`/api/roles/${roleName}/permissions`, { permissions }),
};
